var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon3Ar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5C11.7761 5 12 4.77614 12 4.5C12 4.22386 11.7761 4 11.5 4H4.83333C4.55719 4 4.33333 4.22386 4.33333 4.5V11.1667C4.33333 11.4428 4.55719 11.6667 4.83333 11.6667C5.10948 11.6667 5.33333 11.4428 5.33333 11.1667V5.70711L11.1464 11.5202C11.3417 11.7155 11.6583 11.7155 11.8536 11.5202C12.0488 11.325 12.0488 11.0084 11.8536 10.8131L6.04044 5H11.5Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon3Ar);
export default __webpack_public_path__ + "static/media/link-icon-3-ar.bf94f1195a6235179efe74aab79a911a.svg";
export { ForwardRef as ReactComponent };